import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const DashboardIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                stroke={color}
                strokeWidth="1.5"
                d="M14.548 2.464h5.166c.69 0 1.25.56 1.25 1.25v5.167c0 .69-.56 1.25-1.25 1.25h-5.166c-.69 0-1.25-.56-1.25-1.25V3.714c0-.69.56-1.25 1.25-1.25z"
            ></path>
            <path
                stroke={color}
                strokeWidth="1.5"
                d="M14.548 13.298h5.166c.69 0 1.25.56 1.25 1.25v5.167c0 .69-.56 1.25-1.25 1.25h-5.166c-.69 0-1.25-.56-1.25-1.25v-5.167c0-.69.56-1.25 1.25-1.25z"
            ></path>
            <path
                stroke={color}
                strokeWidth="1.5"
                d="M3.714 2.464h5.167c.69 0 1.25.56 1.25 1.25v5.167c0 .69-.56 1.25-1.25 1.25H3.714c-.69 0-1.25-.56-1.25-1.25V3.714c0-.69.56-1.25 1.25-1.25zM3.714 13.298h5.167c.69 0 1.25.56 1.25 1.25v5.167c0 .69-.56 1.25-1.25 1.25H3.714c-.69 0-1.25-.56-1.25-1.25v-5.167c0-.69.56-1.25 1.25-1.25z"
            ></path>
        </svg>
    );
};

export default React.memo(DashboardIcon);
